<template>
  <div>
    <panel
      Title="پرسش و پاسخ‌های متداول"
      Des="از طریق این فرم می‌توانید پرسش‌ها و پاسخ‌های متداول را مدیریت کنید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <div class="row px-3">
      <div class="col-12 col-md-12 mx-md-2 p-md-3">
        <net-pa-card>
          <template slot="header">
            <h6 class="text-right">
              <i class="fas fa-question-circle ml-2"></i>لیست پرسش‌ها و پاسخ‌های متداول
            </h6>
          </template>
          <template slot="content">
            <vue-bootstrap4-table
              :rows="rows"
              :columns="columns"
              :config="config"
              :classes="classes"
              :actions="actions"
              @on-add="onAdd"
            >
              <template slot="sort-asc-icon">
                <i class="fa fa-sort-up"></i>
              </template>
              <template slot="sort-desc-icon">
                <i class="fa fa-sort-down"></i>
              </template>
              <template slot="no-sort-icon">
                <i class="fa fa-sort"></i>
              </template>
              <template slot="empty-results">
                <p class="text-right">اطلاعاتی یافت نشد</p>
              </template>
              <template slot="Action" slot-scope="props">
                <button
                  type="button"
                  title="حذف"
                  class="btn btn-danger ml-2"
                  @click="onDelete(props.row)"
                  style="font-size: 14px !important"
                  dir="ltr"
                >
                  <span class="fas fa-trash" tabindex="-1"></span>
                </button>
              </template>
            </vue-bootstrap4-table>
          </template>
        </net-pa-card>
      </div>
    </div>
  </div>
</template>

<script>
import Panel from '../Tools/NetPa/Panel.vue'
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
import VueBootstrap4Table from 'vue-bootstrap4-table'

export default {
  components: {
    Panel,
    NetPaCard,
    VueBootstrap4Table,
  },
  data() {
    return {
      rows: [],
      columns: [
        {
          label: 'id',
          name: 'id',
          visibility: false,
        },
        {
          label: 'سوال',
          name: 'question',
        },
        {
          label: 'پاسخ',
          name: 'answer',
        },
        {
          label: 'تاریخ ایجاد',
          name: 'createdDate',
        },
        {
          label: 'عملیات',
          name: 'Action',
          visibility: true,
        },
      ],
      config: {
        pagination: true,
        pagination_info: false,
        per_page: 10,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: '',
        card_mode: false,
        global_search: {
          placeholder: ' جستجو',
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
        },
      },
      classes: {
        table: 'table-bordered table-striped table-sm ',
      },
      actions: [
        {
          btn_text: '<i style="font-size:15px" class="fas fa-plus"></i>',
          event_name: 'on-add',
          class: 'btn btn-success rounded',
          event_payload: {
            msg: 'my custom msg',
          },
        },
      ],
    }
  },
  methods: {
    getFAQList() {
      var axios = require('axios')
      var config = {
        method: 'GET',
        url: this.$GetapiBase() + 'FAQ/Get',
        headers: {
          'Content-Type': 'application/json',
        },
      }

      axios(config)
        .then((response) => {
          if (response.data && response.data.status === 'Ok' && response.data.result && Array.isArray(response.data.result) && response.data.result.length > 0) {
            let allItems = response.data.result.filter(item => item.isDeleted === false)
            
            this.rows = allItems.map((item, index) => {
              return {
                id: item.id,
                question: item.question,
                answer: item.answer,
                createdDate: item.createdDate || '',
              }
            })
          } else {
            this.rows = []
          }
        })
        .catch((error) => {
          console.error('Error fetching FAQ data:', error)
          this.rows = []
          this.$mySweetDefaultTost('خطا', 'خطا در دریافت اطلاعات', 'error', 2000)
        })
        .finally(() => {
          this.loadingRender = false
        })
    },
    onAdd() {
      this.$router.push({ name: 'FAQCreate' })
    },
    onDelete(row) {
      this.$swal({
        title: 'حذف پرسش و پاسخ',
        text: 'آیا مطمئن هستید که می‌خواهید این پرسش و پاسخ را حذف کنید؟',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'بله، حذف کن',
        cancelButtonText: 'انصراف',
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteFAQ(row.id)
        }
      })
    },
    deleteFAQ(id) {
      const formData = new FormData()
      formData.append('id', id)
      
      const DataAxiosDeleteFAQ = {
        ArryfildValue: formData,
        Method: 'DELETE',
        Action: 'FAQ/Delete',
        Token: this.$session.get('TokenNetPa'),
      }
      
      this.$PostFormData(DataAxiosDeleteFAQ)
        .then((data) => {
          if (data.status === 'Ok' || data.success === true) {
            this.$mySweetDefault('حذف موفق', 'پرسش و پاسخ با موفقیت حذف شد', 'success', 2000)
            this.getFAQList()
          } else {
            this.$mySweetDefaultTost('خطا', 'خطا در حذف پرسش و پاسخ', 'error', 2000)
          }
        })
        .catch((error) => {
          console.error('Error deleting FAQ:', error)
          this.$mySweetDefaultTost('خطا', 'خطا در حذف پرسش و پاسخ', 'error', 2000)
        })
    },
  },
  mounted() {
    this.getFAQList()
  },
}
</script>

<style scoped>
</style>

